<app-crear-editar [title]="title()" icono="campaign" [loading]="!form">
  @if (form) {
    <form
      [formGroup]="form"
      id="form-sirena"
      (ngSubmit)="onSubmit()"
      autocomplete="off"
    >
      <!-- Chip ID readonly-->
      <section class="inputs-group">
        <mat-form-field style="width: 100%">
          <mat-label>Chip ID</mat-label>
          <input matInput formControlName="chipId" />
        </mat-form-field>
      </section>

      <!-- Camaras (solo con módulo de cámaras habilitado) -->
      @if (permisosEntidades.verModuloCamaras()) {
        <section class="inputs-group">
          <ng-select
            [items]="camaras"
            bindLabel="identificacion"
            bindValue="_id"
            [multiple]="true"
            [closeOnSelect]="false"
            placeholder="Camaras"
            style="width: 100%"
            [fixedPlaceholder]="true"
            formControlName="idsAsignados"
            appendTo="body"
            notFoundText="Sin resultados"
          >
            <ng-template ng-option-tmp let-item="item">
              <div class="row-flex-start" style="width: 100%; gap: 10px">
                <div>
                  {{ item.identificacion }}
                </div>
                <div>
                  {{ item.tipo }}
                </div>
              </div>
            </ng-template>
          </ng-select>
        </section>
      }

      <!-- Modelo  -->
      <section class="inputs-group">
        <app-modelo-dispositivo-selector
          style="width: 100%"
          formControlName="idModelo"
          [tipo]="'Sirena'"
          [showCrearBtn]="
            helper.tienePermiso('Configuraciones - Crear modelos sirenas')
          "
        ></app-modelo-dispositivo-selector>
      </section>
    </form>
  }

  <ng-container actions>
    <button irxBoton="secundario" type="button" (click)="this.helper.volver()">
      Cancelar
    </button>
    <button
      irxBoton="principal"
      type="submit"
      form="form-sirena"
      [disabled]="!this.form?.valid"
    >
      <mat-icon>save</mat-icon>
      Guardar
    </button>
  </ng-container>
</app-crear-editar>
